import { AdjustmentTypeText } from 'enums';
import { PaymentDetail } from 'types';

export default function getPaymentTypeDescription(detail: PaymentDetail) {
    const description = [
        detail.transactionDescription,
        detail.marBillTypeDescription,
        detail.marBillCodeDescription,
    ].map(value => value?.trim()).find(Boolean);

    return description ?? AdjustmentTypeText[detail.adjustmentTypeId] ?? 'Not Found';
}
